import { render, staticRenderFns } from "./quemSomos.vue?vue&type=template&id=709b305b&scoped=true&"
import script from "./quemSomos.vue?vue&type=script&lang=js&"
export * from "./quemSomos.vue?vue&type=script&lang=js&"
import style0 from "./quemSomos.vue?vue&type=style&index=0&id=709b305b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b305b",
  null
  
)

export default component.exports